export const IMPACT_COLOR_PRESETS: string[] = [
  '#008000',
  '#99CC00',
  '#FFFF00',
  '#FFCC00',
  '#FF0000'
];
